import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Nature } from '@/types';

interface NatureState {
  natures: Nature[];
}

const initialState: NatureState = { natures: [] };

const natureSlice = createSlice({
  name: 'nature',
  initialState,
  reducers: {
    setNatures(state, action: PayloadAction<Nature[]>) {
      state.natures = action.payload;
    },
    addNature(state, action: PayloadAction<Nature>) {
      state.natures.push(action.payload);
    },
    removeNature(state, action: PayloadAction<Nature>) {
      state.natures = state.natures.filter((n) => n.id !== action.payload.id);
    },
    editNature(state, action: PayloadAction<Nature>) {
      const i = state.natures.findIndex((n) => n.id === action.payload.id);
      if (i !== -1) state.natures[i] = action.payload;
    },
  },
});

export const { setNatures, addNature, removeNature, editNature } = natureSlice.actions;
export default natureSlice.reducer;
